/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/anchor-has-content */
import React, { useRef, useState } from "react";
import CloseIcon from '@material-ui/icons/Close';
import { toAbsoluteUrl } from "../../_metronic/utils/utils";
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import { addAttributes} from "../crud/auth.crud";

import Alert from '@material-ui/lab/Alert'

import CircularProgress from '@material-ui/core/CircularProgress';


export default function InvoiceAttributes({onUpdate,onClose,jobRequest,serviceTypes}) {

  
 const [selectedAttributes,setSelectedAttributes] = useState([]);
 const [status,setStatus] = useState({flag:false, statusColor:'',statusMessage:'',loading:false});

  const handleChange = (event) => {
    var chk = selectedAttributes;
  
    let index = chk.findIndex(x=> x ==event.target.value)
			//console.log("index::::",index);
			if(index===-1)
			{
				chk.push(event.target.value);
			}
			else
			{
				chk.splice(index,1);
			}

      setSelectedAttributes(chk);

  }


  const add = () => {
    //this.setState({selectedDate : date});
    setStatus({flag:true,statusColor:'green',statusMessage:'Generating invoice. Please wait.',loading:true});
    addAttributes(jobRequest.id,{jobServiceTypeId:selectedAttributes})
    .then(resp => {
      //console.log("add",resp);
      setStatus({flag:true,statusColor:'green',statusMessage:'Invoice has been generated succesfully',loading:false});

      //this.setState({shareStatus:true})
      onUpdate()
    })

  }
  

  return (
    <>
      <div className="kt-portlet kt-portlet--height-fluid">
        <div className="kt-portlet__head">
          <div className="kt-portlet__head-label">
            <h3 className="kt-portlet__head-title">{jobRequest.pEntity.firstName + " " + jobRequest.pEntity.lastName}</h3>
          </div>
          <div className="kt-portlet__head-toolbar">
            <a href="#" onClick={onClose}><CloseIcon style={{ color: '#5867dd',fontSize: 25}} /> </a>
          </div>
        </div>
        <div className="kt-portlet__body">
          <div className="kt-widget4">
          <div className="kt-widget4__item">
               <div className="kt-widget4__pic kt-widget4__pic--pic">
                 
               </div>
               <div className="kt-widget4__info">
                 <a
                   className="kt-widget4__username"
                   href="#"
                 />
                 <a
                   className="kt-widget4__title"
                   href="#"
                 >
                  Services
                 </a>
                 <p className="kt-widget4__text">Choose the services done for invoice generation</p>
               </div>
               <span className="kt-widget4__number kt-font-brand"></span>
             </div>
            {serviceTypes.map((st)=>(
               <div className="kt-widget4__item">
               <div className="kt-widget4__pic kt-widget4__pic--pic">
                 <img
                   alt=""
                   src={toAbsoluteUrl("/media/client-logos/logo1.png")}
                 />
               </div>
               <div className="kt-widget4__info">
                 <a
                   className="kt-widget4__username"
                   href="#"
                 />
                 <a
                   className="kt-widget4__title"
                   href="#"
                 >
                  {st.serviceType}
                 </a>
                 <p className="kt-widget4__text">{st.serviceTypeDescription}</p>
               </div>
               <span className="kt-widget4__number kt-font-brand"><Checkbox name={'selectServiceTypes'} onChange={handleChange} value={st.jobServiceTypeId} /></span>
             </div>
            

            ))}
           
          </div>
          
        </div>
        <div className="kt-portlet__foot">
        {!status.flag && (
            <Button
                variant="outlined"
                color="primary"
                endIcon={<Icon>send</Icon>}
                onClick={add}
                style={{'margin':'5px'}}
                >
                Generate Invoice
              </Button>
        )}
              {status.flag && (
                <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                      <Alert icon={status.loading && <CircularProgress size={15} />}>&nbsp;&nbsp;{status.statusMessage}</Alert>      
                  </div>
                      )}
				
          </div>
      </div>
    </>
  );
}
